import React from "react";
import PropTypes from "prop-types";
import {makeStyles, Typography, Box, useTheme} from "@material-ui/core";
import {retrieveContentfulImage} from "../../../common/image";
import {CustomButton, CustomChip} from "@hapinest/theme";
import {ADDITIONAL_SERVICES_STATUS} from "../../../common/constant";
import {useI18N} from "../../../common/common";
import CheckCircle1 from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/interface-essential/form-validation/check-circle-1.svg";
import clsx from "clsx";
import {useBreakpoints} from "../../../hooks";

const useStyles = makeStyles((theme) => ({
    root: {
        height: "100%",
        padding: theme.spacing(2)
    },
    available: {
        transition: "background-color 0.3s ease-in-out", // Adding transition for a smooth effect
        "&:hover": {
            backgroundColor: theme.palette.primary["100"], // Background color on hover
        },
        cursor: "pointer",
        borderRadius: theme.spacing(1),
    },
    image: {
        width: "100%"
    },
    imageDisabled: {
        opacity: "40%",
        backgroundColor: theme.palette.background.white
    },
    chip: {
        "& .MuiAvatar-colorDefault": {
            padding: "4px",
        }
    }
}));

const ResortServiceEntry = ({entry, status, onClick}) => {
    const {i18n} = useI18N();
    const theme = useTheme();
    const classes = useStyles();
    const {isExtraSmallScreen} = useBreakpoints();

    return (
        <Box
            display="flex"
            flexDirection="column"
            className={clsx(classes.root, classes.available)}
            onClick={() => onClick(entry)}
        >
            <Box position={"relative"}>
                {entry?.booked &&
                    <Box
                        position={"absolute"}
                        right={`${theme.spacing(2)}px`}
                        top={`${theme.spacing(2)}px`}
                        zIndex={1}
                    >
                        <CustomChip
                            className={classes.chip}
                            label={i18n("view.reservations.reserved")}
                            onImage
                            avatarIcon={<CheckCircle1 />}
                        />
                    </Box>
                }

                <img
                    alt={entry?.title}
                    src={entry?.image?.url
                        ? retrieveContentfulImage(entry?.image?.url, isExtraSmallScreen() ? { width: 568, height: 256, fit: "fill" } : (isExtraSmallScreen() ? { width: 422, height: 162, fit: "fill" } : { width: 278, height: 162, fit: "fill" }))
                        : `/images/service_packagetype_${entry?.packageType}.jpg`
                    }
                    className={clsx(
                        classes.image, { [classes.imageDisabled]: entry.booked }
                    )}
                />
            </Box>

            <Box
                flex={1}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
            >
                <Box
                    mt={3}
                    className="ResortServiceEntry-content"
                >
                    <Typography
                        variant="h4"
                        component="h3"
                        gutterBottom
                    >
                        {entry?.title}
                    </Typography>

                    <Typography
                        variant="body1"
                    >
                        {entry?.shortDescription}
                    </Typography>
                </Box>
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    mt={3}
                    className="ResortServiceEntry-actions"
                >
                    <CustomButton
                        variant={!entry?.booked ? "contained" : "outlined"}
                        size={"small"}
                    >
                        <>
                            {!entry?.booked ? (
                                status === ADDITIONAL_SERVICES_STATUS.READY_TO_REQUEST ? (
                                    entry?.canBeBookedDirectly ? (
                                        i18n("common.label.reserve")
                                    ) : (
                                        i18n("common.label.request")
                                    )
                                ) : (
                                    i18n("common.label.see_details")
                                )
                            ) : (
                                i18n("view.reservations.services.label.cancel")
                            )}
                        </>
                    </CustomButton>
                </Box>
            </Box>
        </Box>
    );
};

ResortServiceEntry.propTypes = {
    entry: PropTypes.object.isRequired,
    status: PropTypes.number,
    onClick: PropTypes.func
};

export default ResortServiceEntry;

